export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Thin.b12dd7a.woff";